import React from 'react';
import Insta from '../assets/img/insta.png';
import Linkdin from '../assets/img/link.png';
import Youtube from '../assets/img/youtube.png';
import Whatsaap from '../assets/img/whatsapp.png';
import { Link } from "react-router-dom";
const Footer = () => {
    return (
        <>
        <div className='whatsappbtn'>
            <a href='https://wa.me/919899604722?text=Hii'><img src={Whatsaap}></img></a>
        </div>
        <footer>
            <div className="container">
                <div className="socialfeed">
                    <a href="https://www.instagram.com/bhavna555/?hl=en"><img src={Insta} alt="" /><span> Instagram</span></a>
                    <a href="#"><img src={Linkdin} alt="" /><span> LinkedIn</span></a>
                    <a href="https://www.youtube.com/@bhavnasingh555"><img src={Youtube} alt="" /><span> Youtube</span></a>
                </div>
                <div className="copy-nav">
                    <p>© 2024 Bhavana Singh</p>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li><a href="/courses/personality-transformation-online-courses">Online Courses</a></li>
                        <li><a href="/courses/personality-transformation-offline-courses">Offline Courses</a></li>
                        <li><a href="/contact">Contact</a></li>
                        <li><a href="/about-us">About</a></li>
                    </ul>
                </div>
            </div>
        </footer>
        </>
    );
};

export default Footer;
